export default "__VITE_ASSET__BQv5fnJI__"